import en from './en/default.json';
import fa from './fa/default.json';

const useLocale = (lang) => {
  if (lang === 'en') return en;
  return fa;
};

export default useLocale;
